import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const features = [
  {
    title: "Daily QA Sessions",
    desc: "Interactive sessions to track your progress and clarify doubts every day.",
    img: "/images/qa.jpg",
  },
  {
    title: "Assignments",
    desc: "Practical exercises for each module to reinforce your learning.",
    img: "/images/assignment.jpg",
  },
  {
    title: "Doubt Clearing",
    desc: "Get your questions answered by experts and mentors promptly.",
    img: "/images/doubt.jpg",
  },
  {
    title: "Mock Interviews",
    desc: "Simulated interviews to prepare you for real-world scenarios.",
    img: "/images/mock.jpg",
  },
  {
    title: "Resume Assistance",
    desc: "Help with creating a professional resume to impress recruiters.",
    img: "/images/resume.jpg",
  },
  {
    title: "Career Guidance",
    desc: "Expert advice to guide you in landing your dream job in tech.",
    img: "/images/carrer.jpg",
  },
];

const JobAssistance = () => {
  return (
    <Container className="my-5">
      <h2 className="mb-4 text-center">Job Assistance Program</h2>
      <Row className="g-4">
        {features.map((feature, index) => (
          <Col key={index} xs={12} sm={6} md={4}>
            <Card className="h-100 shadow-sm text-center p-3">
              {feature.img && (
                <Card.Img
                  src={feature.img}
                  alt={feature.title}
                  style={{ width: "80px", height: "80px", objectFit: "contain", margin: "0 auto" }}
                  className="mb-3"
                />
              )}
              <Card.Body>
                <Card.Title>{feature.title}</Card.Title>
                <Card.Text>{feature.desc}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default JobAssistance;
